import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { NgbModalConfig, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap'
import { OAuthService } from 'angular-oauth2-oidc'
import { authConfig } from './core/configuration/auth.config'
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks'
import { AsyncPipe, DOCUMENT, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr'
import { ChantierDomainService } from './shared/domain/chantier.domain'
import { map, Observable } from 'rxjs'
import { HostEnvironmentLoader } from './core/services/host-environment-loader.service'
import { GlobalSpinnerComponent } from './core/ui/global-spinner/global-spinner.component'
import { GlobalDomainService } from './shared/domain/global.domain'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, AsyncPipe, GlobalSpinnerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
    protected readonly theme$: Observable<string>
    protected readonly displayGlobalSpinner$: Observable<boolean>
    protected readonly globalSpinnerMessages$: Observable<string[]>
    private configModal: NgbModalConfig
    private configTooltip: NgbTooltipConfig
    private oauthService: OAuthService
    private readonly chantierDomainService: ChantierDomainService
    private readonly hostLoader: HostEnvironmentLoader
    private readonly document: Document
    private readonly globalDomainService: GlobalDomainService

    constructor() {
        this.globalDomainService = inject(GlobalDomainService)
        this.configModal = inject(NgbModalConfig)
        this.configTooltip = inject(NgbTooltipConfig)
        this.oauthService = inject(OAuthService)
        this.chantierDomainService = inject(ChantierDomainService)
        this.hostLoader = inject(HostEnvironmentLoader)
        this.document = inject(DOCUMENT)

        this.theme$ = this.chantierDomainService.selectedChantierIsIris$.pipe(
            map((isIris: boolean) => (isIris ? 'iris' : 'chantier')),
        )
        this.displayGlobalSpinner$ = this.globalDomainService.displayGlobalSpinner$
        this.globalSpinnerMessages$ = this.globalDomainService.globalSpinnerMessage$

        this.configureModal()
        this.configureTooltip()
        this.configureAuthService()
        this.hostLoader.loadViaDomainName(this.document.location.host)
        registerLocaleData(localeFr)
    }

    ngOnInit(): void {
        this.removeStartupLoader()
    }

    removeStartupLoader(): void {
        const startupLoader: HTMLElement | null = document.getElementById('startup-loader')
        if (startupLoader) {
            startupLoader.remove()
        }
    }

    private configureTooltip(): void {
        this.configTooltip.container = 'body'
        this.configTooltip.openDelay = 600
    }

    private configureModal(): void {
        this.configModal.centered = true
        this.configModal.backdrop = 'static'
    }

    private configureAuthService(): void {
        this.oauthService.configure(authConfig)
        this.oauthService.tokenValidationHandler = new JwksValidationHandler()
        this.oauthService.setStorage(localStorage)
    }
}
